<template>
  <div id="app">

    <!-- Loader -->
    <div v-if="(loading && !DBitems) || $store.state.loading"
      class="d-flex flex-row justify-content-center loading_card">
      <div style="position: fixed; top: 40%;">
        <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3" color="var(--primary-color)" />
      </div>
    </div>

    <div v-else>
      <!-- News Ticker -->
      <news_ticker v-if="$store.state.last_news != 0" />

      <!-- Header -->
      <component :is="currentHeader" v-if="$store.state.showHeader" />

      <!-- Main Content -->
      <main v-if="isTheme(5, 7)">
        <div class="main_content">
          <router-view name="theme5" />
        </div>
      </main>

      <div v-else>
        <router-view v-if="isTheme(1, 6)" />
        <router-view name="theme2" v-else-if="isTheme(2)" />
        <router-view name="theme3" class="theme3" v-else-if="isTheme(3)" />
        <router-view name="theme8" class="theme8" v-else-if="isTheme(8, 9)" />
        <router-view name="theme10" class="theme10" v-else-if="isTheme(10, 12)" />
        <router-view name="theme11" v-else-if="isTheme(11)" />
        <router-view name="theme13" v-else-if="isTheme(13)" />
        <router-view name="theme15" v-else-if="isTheme(15)" />


      </div>

      <!-- Footer -->
      <component :is="currentFooter" v-if="$store.state.showFooter"/>

      <!-- Not Found -->
      <div style="text-align:center; margin-top:100px" v-if="NotFound">
        <a>
          <img style="max-width:250px" src="https://etrolley.net/websiteImages/logoAR.png" />
        </a>
        <h3 dir="ltr">Sorry, this store is not available !!</h3>
        <h3>عذراً هذا المتجر غير متاح !!</h3>
      </div>
    </div>

  </div>
</template>

<script>
import {
  HalfCircleSpinner,
  HollowDotsSpinner,
  CirclesToRhombusesSpinner
} from "epic-spinners";

import HeaderComponent from "./components/Header.vue";
import FooterComponent from "./components/Footer.vue";
import HeaderComponent2 from "./Them2/components/Header.vue";
import FooterComponent2 from "./Them2/components/Footer.vue";
import HeaderComponent3 from "./Them3/components/Header.vue";
import FooterComponent3 from "./Them3/components/Footer.vue";
import HeaderComponent5 from "./theme5/components/header.vue";
import FooterComponent5 from "./theme5/components/footer.vue";
import HeaderComponent8 from "./theme8/components/header.vue";
import FooterComponent8 from "./theme8/components/footer.vue";
import HeaderComponen10 from "./theme10/components/header.vue";
import FooterComponent10 from "./theme10/components/footer.vue";
import HeaderComponent11 from "./theme11/components/Header.vue";
import FooterComponent11 from "./theme11/components/Footer.vue";
import HeaderComponent13 from "./theme13/components/header.vue";
import FooterComponent13 from "./theme13/components/footer.vue";
import HeaderComponent15 from "./theme15/components/header.vue";
import FooterComponent15 from "./theme15/components/footer.vue";
import news_ticker from "./components/news_ticker.vue";

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    HeaderComponent2,
    FooterComponent2,
    HeaderComponent3,
    FooterComponent3,
    HeaderComponent5,
    FooterComponent5,
    HeaderComponent8,
    FooterComponent8,
    HeaderComponen10,
    FooterComponent10,
    HeaderComponent11,
    FooterComponent11,
    HeaderComponent13,
    FooterComponent13,
    HeaderComponent15,
    FooterComponent15,
    news_ticker,
    HalfCircleSpinner,
    HollowDotsSpinner,
    CirclesToRhombusesSpinner
  },

  data() {
    return {
      DBitems: null,
      loading: false,
      NotFound: false,
      currentMessage: "",
      notify: false
    };
  },

  computed: {
    isTheme5or7() {
      return [5, 7].includes(this.$store.state.theme_id);
    },
    currentHeader() {

      const id = this.$store.state.theme_id;
      console.log('id: ', id)
      if ([1, 6].includes(id)) return "header-component";
      if (id === 2) return "header-component2";
      if (id === 3) return "header-component3";
      if ([5, 7].includes(id)) return "header-component5";
      if ([8, 9].includes(id)) return "header-component8";
      if ([10, 12].includes(id)) return "HeaderComponen10";
      if (id === 11) return "header-component11";
      if (id === 13) { return "header-component13" };
       if (id === 15) { return "header-component15" };

      return null;
    },
    currentFooter() {
      const id = this.$store.state.theme_id;
      if ([1, 6].includes(id)) return "footer-component";
      if (id === 2) return "footer-component2";
      if (id === 3) return "footer-component3";
      if ([5, 7].includes(id)) return "footer-component5";
      if ([8, 9].includes(id)) return "footer-component8";
      if ([10, 12].includes(id)) return "footer-component10";
      if (id == 11) return "footer-component11";
      if (id == 13) return "footer-component13";
       if (id == 15) return "footer-component15";
      return null;
    }
  },

  methods: {
    isTheme(...ids) {
      return ids.includes(this.$store.state.theme_id);
    },

    async fetchStoreData() {
      console.log('jjjjj')
      try {
        this.loading = true;
        const storeName = this.$store.state.storeName;
        this.$store.storeName = storeName;

        const appearanceRes = await this.axios.get(`${this.$store.state.base_api_url}${storeName}/apperance_home`);
        const data = appearanceRes.data.data;
        console.log(data)

        Object.assign(this.$store.state, {
          apperance_slider: data.slider,
          apperance_sections: data.sections,
          apperance_offers: data.offers,
          apperance_brands: data.brands,
          apperance_map: data.map,
          apperance_map_address: data.map_address,
          apperance_lang: data.lang,
          apperance_basic_lang: data.basic_lang,
          apperance_latest_products: data.latest_products,
          apperance_best_saller: data.best_saller,
          apperance_fetured_products: data.fetured_products,
          digit_price: data.digit_price,
          guest_orders: data.guest_orders,
          gift_orders: data.gift_orders
        });

        this.$i18n.locale =data.basic_lang;
             
        if(this.$i18n.locale=='ar'){
        document.documentElement.setAttribute("dir", "rtl");
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')}

        const storeRes = await this.axios.get(`${this.$store.state.base_api_url}${storeName}`);
        const storeData = storeRes.data;

        console.log(storeData)

        if (storeData.code == 1) {
          this.DBitems = storeData.data;
          this.initializeStoreData(storeData.data[0]);
          this.loading = false;
        } else if (storeData.code == -1) {
          this.NotFound = true;
        }
      } catch (error) {
        console.error("Error fetching store data", error);
        this.loading = false;
      }
    },
    // API المواد (منفصل)
    async fetchMetrialData() {
      try {
        const url = "https://etrolley.net/api/etrollymarket/metrial";
        const response = await this.axios.get(url);
        const data = response.data;

        // تحديث state منفصل للمواد
        this.$store.state.gold = data.data.gold;
        this.$store.state.silver = data.data.silver;
      } catch (error) {
        console.error("Error fetching metrial data", error);
      }
    },

    initializeStoreData(store) {
      const state = this.$store.state;
      Object.assign(state, {
        unit: store.unit_en,
        unitAR: store.unit_ar,
        UnitPrice: this.$i18n.locale === 'ar' ? store.unit_ar : store.unit_en,
        tax: store.tax,
        logo: store.logo,
        logo_footer: store.logo_footer,
        theme_id: Number(store.theme),
        title_en: store.title_en,
        title_ar: store.title_ar,
        description_en: store.description_en,
        description_ar: store.description_ar,
        keyword_en: store.keyword_en,
        keyword_ar: store.keyword_ar,
        country_code: store.country_code,
        country_flag: store.country_flag,
        country_length: store.country_length,
        phone: store.phone,
        email: store.email,
        auth: store.auth,
        master_code: store.master_code,
        sms_type: store.sms_type,
        last_news: store.last_news
      });
        console.log('///////*************///////',this.$store.state.theme_id)
      const root = document.querySelector(":root");
      root.style.setProperty("--primary-color", store.primary_color);
      root.style.setProperty("--secondary-color", store.secondry_color);

      document.title = this.$i18n.locale === 'ar' ? store.title_ar : store.title_en;
      document.getElementById("description_meta").content = this.$i18n.locale === 'ar' ? store.description_ar : store.description_en;
      document.getElementById("keywords_meta").content = this.$i18n.locale === 'ar' ? store.keyword_ar : store.keyword_en;

      if (state.last_news != 0) {
        document.body.classList.add("ticker_news");
      }

      this.applyThemeCSS(store.theme);
        let h2 = document.querySelector('body');

            h2.classList.add("theme"+store.theme);
      //this.applyThemeCSS(13);
    },

    applyThemeCSS(themeId) {

      console.log('********************************** ', themeId);
      const themeCSSMap = {
        13: `<link href="/theme13/assest/style.css" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
                 `,
        15: `<link href="/theme15/assest/style9.css" rel="stylesheet">
           <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
           `,
        8: `
          <link href="/theme8/libs/tiny-slider/tiny-slider.css" rel="stylesheet">
          <link href="/theme8/libs/@mdi/font/css/materialdesignicons.min.css" rel="stylesheet">
          <link href="/theme8/css/tailwind4.css" rel="stylesheet">`,
        10: `
          <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet">
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
          <link rel="stylesheet" type="text/css" href="/theme10/style/style.css">`,
        5: `
          <link rel="stylesheet" href="/pet_shop/assets/css/animate.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/ionicons.min.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/themify-icons.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/linearicons.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/flaticon.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/simple-line-icons.css">
          <link rel="stylesheet" href="/pet_shop/assets/owlcarousel/css/owl.carousel.min.css">
          <link rel="stylesheet" href="/pet_shop/assets/owlcarousel/css/owl.theme.css">
          <link rel="stylesheet" href="/pet_shop/assets/css/slick.css">
          <link id="style" href="/pet_shop/assetsrtl/css/style.css" rel="stylesheet">
          <link rel="stylesheet" id="stylertl" href="/pet_shop/assetsrtl/css/rtl-style.css">`,
        17:`<!-- Icon CSS -->
	<link href="/theme17/assets/css/vendor/materialdesignicons.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/remixicon.css" rel="stylesheet">

	<!-- Vendor -->
	<link href="/theme17/assets/css/vendor/bootstrap.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/animate.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/owl.carousel.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/slick.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/swiper-bundle.min.css" rel="stylesheet">
	<link href="/theme17/assets/css/vendor/nouislider.css" rel="stylesheet">

	<!-- Main CSS -->
	<link id="mainCss" href="/assets/css/style.css" rel="stylesheet">`,
        default: `
        <link id="mainCss" href="/assets/css/style.css" rel="stylesheet">
        <link id="bootstrap" href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
            <link id="allmin" rel="stylesheet"  href="/assets/css/all.min.css">
           <link id="bootstrapbox" href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
           <link id="bootstrapglight" href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
           <link id="remixicon" href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
           <link id="swiper" href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">
          <link id="style" rel="stylesheet"  href="/assets/css/style.css">
          <link id="bootstrapbox" href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
          <link id="bootstrapglight" href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
          <link id="remixicon" href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
          <link id="swiper" href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">`
      };

      const styleElement = document.getElementById("style");
      if (styleElement) {
        styleElement.innerHTML = themeCSSMap[themeId] || themeCSSMap.default;
      }

      if ([7].includes(themeId)) {
        document.body.classList.add("dark_mode", "theme5");
        document.body.style.backgroundColor = "black";
        document.body.style.color = "var(--primary-color)";
      }
    },

    receiveMessage() {
      try {
        this.$messaging.onMessage(payload => {
          this.currentMessage = payload;
          this.setNotificationBoxForm(payload.notification.title, payload.notification.body);
          this.notify = true;
          this.$store.state.notificationUpdate = !this.$store.state.notificationUpdate;

          setTimeout(() => (this.notify = false), 10000);
        });
      } catch (e) {
        console.error("Error in receiveMessage:", e);
      }
    }
  },

  mounted() {
    try {
      this.$messaging
        .getToken({
          vapidKey: "BDOMKCvpZbjN6yH3n3A3cNhV7_k7P6cucJmbgBJmiQVzSQUTHcaGaJQLfQic_WuY13FQfuANYrRhxlxYDqZcffA"
        })
        .then(token => {
          if (token) {
            this.$store.state.fsm_token = token;
            return fetch(`https://iid.googleapis.com/iid/v1/${token}/rel/topics/${this.$store.storeName}`, {
              method: "POST",
              headers: {
                Authorization: `key=AAAArMCrdjc:APA91bGmp4VqB3d7cOAl4zEvy5dflbuGgLc0XkBRiDr-phafDn3e0ki9VmJiwY4aklDADxMDNZKseZGtkmfHXfAV3AaxfB8QxEkmFtdrDo8owdKgQjtqdzjuiD_bx8_OZq6vS7KOoSkw`
              }
            });
          }
        })
        .catch(console.error);

      this.receiveMessage();
    } catch (e) {
      console.error("Error during FCM token handling:", e);
    }
  },

  created() {
     if (this.$route.params.storeName == null) {
     // window.location.href = "/";
    } else {
      this.$store.state.storeName = this.$route.params.storeName;
      console.log(this.$store.storeName);
    }
    this.fetchStoreData();
    this.fetchMetrialData();

    // تشغيل fetchMetrialData تلقائيًا كل 30 دقيقة
    this.intervalId = setInterval(() => {
      this.fetchMetrialData();
    }, 30* 60 * 1000);
  }
};
</script>
